// extracted by mini-css-extract-plugin
module.exports = {"Root":"FullScreenPortalPaper_Root__2F0sL","Paper":"FullScreenPortalPaper_Paper__nhnnt"};